import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { apiFetch } from '../lib/api';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PendingConfirmationsContext = createContext(null);

export function PendingConfirmationsProvider({ children }) {
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const fetchCount = useCallback(async () => {
        try {
            setLoading(true);
            const response = await apiFetch(`${API_URL}/api/staged-loads`, {
                credentials: 'include'
            });
            
            if (response.ok) {
                const data = await response.json();
                setCount(data.count || 0);
            }
        } catch (error) {
            console.error('Failed to fetch pending confirmations count:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    // Fetch on mount
    useEffect(() => {
        fetchCount();
    }, [fetchCount]);

    // Refresh function to be called after staging/confirming/unassigning
    const refresh = useCallback(() => {
        fetchCount();
    }, [fetchCount]);

    const value = {
        count,
        loading,
        refresh
    };

    return (
        <PendingConfirmationsContext.Provider value={value}>
            {children}
        </PendingConfirmationsContext.Provider>
    );
}

export function usePendingConfirmations() {
    const context = useContext(PendingConfirmationsContext);
    if (!context) {
        throw new Error('usePendingConfirmations must be used within a PendingConfirmationsProvider');
    }
    return context;
}
